// import axios from 'axios'
import axios from '../../helpers/Axios'

export const siccodemodule = {

	namespaced: true,

	state: {

		allSicCodes: []
	},
	getters: {

		allSicCodes: state => { return state.allSicCodes; }
	},
	actions: {

		getSicCodes({ commit }) {
			return axios.get('/SicCode').then(response => {

				commit('allSicCodes', response.data);

			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

		allSicCodes(state, sicCodes) {
			state.allSicCodes = sicCodes
		}
	}
}
